import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useCustomerPortal } from '../../contexts/CustomerPortalContext';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';

// Guard de las páginas de billing/pagos/planes Paddle del portal cliente:
// - cuenta gestionada por un partner → la facturación la lleva el partner,
//   estas páginas NO existen para el cliente (redirigir a Mi cuenta);
// - modo impersonación (solo lectura) → tampoco: nada de checkout/planes.
// Mientras no se sabe (loading) se enseña spinner para no redirigir en falso.

const ManagedAccountGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { managedByReseller, loading } = useCustomerPortal();
  const { readOnly } = useCustomerAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (managedByReseller || readOnly) {
    return <Navigate to="/customer/account" replace />;
  }

  return <>{children}</>;
};

export default ManagedAccountGuard;
